import { render, staticRenderFns } from "./HTMLTableComponent.vue?vue&type=template&id=af2475d4&scoped=true&lang=pug"
import script from "./HTMLTableComponent.vue?vue&type=script&lang=ts"
export * from "./HTMLTableComponent.vue?vue&type=script&lang=ts"
import style0 from "./HTMLTableComponent.vue?vue&type=style&index=0&id=af2475d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2475d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af2475d4')) {
      api.createRecord('af2475d4', component.options)
    } else {
      api.reload('af2475d4', component.options)
    }
    module.hot.accept("./HTMLTableComponent.vue?vue&type=template&id=af2475d4&scoped=true&lang=pug", function () {
      api.rerender('af2475d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HTMLTable/HTMLTableComponent.vue"
export default component.exports